var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "note_add_FILL0_wght400_GRAD0_opsz48",
    "data-name": "note add FILL0 wght400 GRAD0 opsz48",
    d: "m1.35,18C.61,17.98.02,17.39,0,16.65V1.35C.02.61.61.02,1.35,0h8.12l4.93,4.93v11.72c-.02.74-.61,1.33-1.35,1.35H1.35Zm7.45-12.47V1.35H1.35v15.3h11.7V5.53h-4.25ZM1.35,1.35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.98,10.45l.92-.2c.1.41.32.57.63.57.26,0,.41-.12.41-.31,0-.23-.3-.33-.66-.46-.52-.17-1.16-.39-1.16-1.13,0-.66.54-1.1,1.32-1.1.63,0,1.32.27,1.47,1.02l-.84.19c-.11-.31-.28-.45-.57-.45-.25,0-.44.11-.44.29,0,.19.27.27.6.38.54.16,1.24.38,1.24,1.2,0,.68-.55,1.13-1.39,1.13-.79,0-1.43-.41-1.53-1.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.82,7.91h.99l-1.32,3.59h-1.15l-1.32-3.59h.99l.9,2.62.9-2.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.81,9.71c0-1.11.78-1.87,1.87-1.87.72,0,1.3.33,1.61.88l-.81.44c-.16-.29-.45-.46-.8-.46-.54,0-.94.41-.94,1.02s.35,1.02.94,1.02c.34,0,.69-.14.84-.52h-.8v-.74h1.71v2.03h-.72v-.39c-.23.27-.57.46-1.08.46-1.06,0-1.81-.76-1.81-1.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.a48f43c2d9b3cfda067f85fab7511df5.svg";
export { ForwardRef as ReactComponent };